import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px 48px;

  display: flex;

  align-items: center;
  justify-content: space-between;
`;

export const InputContainer = styled.div`
  display: flex;

  flex-direction: column;

  align-items: center;
  justify-content: center;

  gap: 30px;
`;

export const ErrorText = styled.div`
  position: relative;
  top: 8px;

  color: ${(props) => props.theme?.colors?.infoRed};
  font: ${(props) => props.theme.fonts?.textSmallHeight14Weight600};
`;

export default {
  Container,
  ErrorText,
};
